<template>
  <Layout>
    <template>
      <PageHeader :title="title2" :items="items"></PageHeader>
    </template>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-form enctype="multipart/form-data" ref="email" class="row">
              <b-form-group class="col-6">
                <div class="my-1 d-flex justify-content-between align-items-center">
                  <label label-for="in-forum" class="mb-1">Member</label>
                </div>
                <multiselect @search-change="fetchMemberList" id="member" v-model="form2.member_id"
                  :options="memberList" :multiple="false" track-by="member_id" label="fnameAndLname"
                  placeholder="Type here to search" :class="{
                    'is-invalid':
                      store && $v.form2.member_id.$invalid,
                  }">
                  <span slot="noOptions"> Type here to search </span>
                </multiselect>
                <span v-if="memberIdError" class="text-danger">{{ memberIdError }}</span>
              </b-form-group>
              <b-form-group id="" label-for="" class="col-6">
                <label>Pan Card</label>
                <input v-model="form2.pan_card" maxlength="10" @input="validatePanCard"
                  placeholder="Enter PAN card number" class="form-control" />
                <span v-if="panCardError" class="text-danger">{{ panCardError }}</span>
              </b-form-group>
              <b-form-group id="" label-for="" class="col-6">
                <label>Bank Name</label>
                <b-form-input id="" placeholder="Enter bank name" v-model="form2.bank_name"></b-form-input>
              </b-form-group>
              <b-form-group id="" label-for="" class="col-6">
                <label>Account Holder Name</label>
                <b-form-input id="" placeholder="Enter account holder name"
                  v-model="form2.account_holder_name"></b-form-input>
              </b-form-group>
              <b-form-group id="" label-for="" class="col-6">
                <label>Account No.</label>
                <b-form-input id="" placeholder="Enter account no." v-model="form2.account_no"></b-form-input>
              </b-form-group>
              <b-form-group id="" label-for="" class="col-6">
                <label>IFSC Code</label>
                <b-form-input id="" placeholder="Enter IFSC code" v-model="form2.ifsc_code"></b-form-input>
              </b-form-group>
              <b-form-group id="" label-for="" class="col-6">
                <label>Branch Name</label>
                <b-form-input id="" placeholder="Enter branch name" v-model="form2.branch_name"></b-form-input>
              </b-form-group>
              <b-form-group class="col-6" label="Pan Card Image" label-for="pan-card-img">
                <b-form-file id="pan-card-img" accept="image/*" @change="readFile($event, 'pan_card_image')"
                  ref="pan_card_image" placeholder="Choose a file [Upload Max File Size : 5MB]">
                </b-form-file>
                <template v-if="
                  $route.name == 'edit-pan-card' &&
                  edit.pan_card_image_url
                ">
                  <img :src="edit.pan_card_image_url" width="128px" height="128px"
                    style="object-fit: contain; margin-top: 5px" />
                </template>
                <template v-if="pan_card_image_url">
                  <img :src="pan_card_image_url" width="128px" height="128px" ref="pan_card_image_url"
                    style="object-fit: contain; margin-top: 5px" />
                </template>
              </b-form-group>
              <b-form-group class="col-6" label="Bank Cheque Image" label-for="bank-cheque-img">
                <b-form-file id="bank-cheque-img" accept="image/*" @change="readFile($event, 'bank_cheque_image')"
                  ref="bank_cheque_image" placeholder="Choose a file [Upload Max File Size : 5MB]">
                </b-form-file>
                <template v-if="
                  $route.name == 'edit-pan-card' &&
                  edit.bank_cheque_image_url
                ">
                  <img :src="edit.bank_cheque_image_url" width="128px" height="128px"
                    style="object-fit: contain; margin-top: 5px" />
                </template>
                <template v-if="bank_cheque_image_url">
                  <img :src="bank_cheque_image_url" width="128px" height="128px" ref="pan_card_image_url"
                    style="object-fit: contain; margin-top: 5px" />
                </template>
              </b-form-group>
              <div class="col-12">
                <b-button type="submit" variant="primary" class="mr-2" @click.prevent="addData">
                  <span>Update Data</span>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import couponMixin from "../../../mixins/ModuleJs/pancard";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  mixins: [MixinRequest, couponMixin],
  data() {
    return {
      submitted: false,
      title2: "Add Pan Card",
      items: [
        {
          text: "Back",
          href: "/pancard",
        },
        {
          text: "Data",
        },
      ],
    };
  },
  validations: {},
};
</script>
